import { render, staticRenderFns } from "./investmentCluesIpo.vue?vue&type=template&id=9cef9f88&"
import script from "./investmentCluesIpo.vue?vue&type=script&lang=js&"
export * from "./investmentCluesIpo.vue?vue&type=script&lang=js&"
import style0 from "./investmentCluesIpo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports